import React from 'react';
import { usePageModeContext } from 'providers/PageMode/PageMode.provider';
import { Default, SecondUpgrade, ChangePlan } from './content';
import { RootStore, withInjectedRootStore } from 'providers';
import { Experiments, PurchaseMode } from 'enums';

const SubHeaderComponent = ({ rootStore }: { rootStore: RootStore }) => {
  const { purchaseMode, isChangePlan: isChangePlanFromPageModeContext } =
    usePageModeContext();
  const {
    isSecondUpgrade,
    isChangePlan: isChangePlanFromAppStore,
    experiments,
  } = rootStore.appStore;

  const isReplaceChangePlanPurchaseModeEnabled =
    experiments[Experiments.ReplaceChangePlanPurchaseMode] === 'true';
  const isChangePlan = () => {
    if (isChangePlanFromAppStore) {
      return true;
    }
    return isReplaceChangePlanPurchaseModeEnabled
      ? isChangePlanFromPageModeContext
      : purchaseMode === PurchaseMode.CHANGE_PLAN;
  };
  if (isSecondUpgrade) {
    return <SecondUpgrade />;
  } else if (isChangePlan()) {
    return <ChangePlan />;
  } else {
    return <Default />;
  }
};

export const SubHeader = withInjectedRootStore(SubHeaderComponent);
